module.exports = __webpack_public_path__ + "img/Susanne_Kirchmayr.5a05ad4e.jpg";